export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Betalningsvillkor";
};

export const detailUrl = ({ id }) => {
  return `/configcenter/rental-notifications/debt-setting/${id}`;
};
